import {Switch} from '@mui/material';
import React from 'react';

const CustomSwitch = ({checked, onChange,label}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        justifyItems: 'center',
      }}>
      <p>{label}</p>
      <Switch onChange={onChange} checked={checked} />
    </div>
  );
};

export default CustomSwitch;
